<template>
  <div id="app" :class="chromeForIosClass">
    <sys-loading :loading="loading"></sys-loading>
    <div v-if="!isMobileClient" class="swiperCont" dir="rtl">
      <swiper ref="leftSlide" :options="swiperOptions1">
        <swiper-slide v-for="(item, idx) in pcLooperImages" :key="idx">
          <a :href="actBaseInfo.returnUrl" target="_blank">
            <img :src="item" alt="" width="100%"/>
          </a>
        </swiper-slide>
      </swiper>
      <div class="prev-btn1 nav-btn" slot="button-prev"></div>
      <div class="next-btn1 nav-btn" slot="button-next"></div>
    </div>
    <router-view v-if="loadedActivityFlag"/>
    <div v-if="!isMobileClient" class="swiperCont">
      <swiper ref="rightSlide" :options="swiperOptions2">
        <swiper-slide v-for="(item, idx) in pcLooperImages" :key="idx">
          <a :href="actBaseInfo.returnUrl" target="_blank">
            <img :src="item" alt="" width="100%"/>
          </a>
        </swiper-slide>
      </swiper>
      <div class="prev-btn2 nav-btn" slot="button-prev"></div>
      <div class="next-btn2 nav-btn" slot="button-next"></div>
    </div>
  </div>
</template>

<script>
import SysLoading from "./components/common/SysLoading"
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import {isMobile} from "./utils/tools"
import {getActivityInfo, getPcImages} from './utils/request'

export default {
  name: 'App',
  components: {SysLoading, swiper, swiperSlide},
  data() {
    return {
      loading: true,
      chromeForIosClass: "",
      loadedActivityFlag: true,
      actBaseInfo: {},
      swiperOptions1: {
        speed: 1000,
        loop: false,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        },
        effect: 'slide',
        navigation: {
          nextEl: ".next-btn1",
          prevEl: ".prev-btn1"
        }
      },
      swiperOptions2: {
        speed: 1000,
        loop: false,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        },
        effect: 'slide',
        navigation: {
          nextEl: ".next-btn2",
          prevEl: ".prev-btn2"
        }
      },
      pcLooperImages: []
    }
  },
  computed: {
    isMobileClient: () => {
      return isMobile()
    }
  },
  mounted() {
    this.setCustomDeviceScale()
    this.getLooperImages()
    this.getActivityBaseInfo()
    this.setCustomDeviceClass()
    document.addEventListener("touchstart", function (event) {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    });
    let lastTouchEnd = 0;
    document.addEventListener("touchend", function (event) {
      let now = new Date().getTime();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    }, false);
    document.addEventListener("gesturestart", function (event) {
      event.preventDefault();
    });
    document.addEventListener('dblclick', function (event) {
      event.preventDefault();
    })
  },
  methods: {
    getActivityBaseInfo() {
      this.loading = true
      this.loadedActivityFlag = false
      getActivityInfo().then(res => {
        if (res.code == 0) {
          this.loading = false
          this.loadedActivityFlag = true
          this.actBaseInfo = res.data[0]
          localStorage.setExpire('actBaseInfo', res.data[0], 1000*60*60*2)
        }
      })
    },
    getLooperImages() {
      this.loading = true
      this.loadedActivityFlag = false
      getPcImages().then(res => {
        if (res.code == 0) {
          this.loading = false
          this.loadedActivityFlag = true
          if (res.data && res.data.length > 0) {
            localStorage.setExpire('mobileBgi', res.data[0].pic, 1000*60*60*2)
            if (!this.isMobileClient) {
              document.querySelector('.pc-class').style.backgroundImage = `url(${res.data[1].pic})`
            }
            res.data.forEach((item, idx) => {
              if (idx > 1) {
                this.pcLooperImages.push(item.pic)
              }
            })
          }
        }
      })
    },
    setCustomDeviceClass() {
      if (!this.isMobileClient) {
        this.chromeForIosClass = 'pc-class'
      } else {
        let u = window.navigator.userAgent
        // 解决苹果谷歌浏览器 地址栏和工具栏遮挡
        if (u.indexOf('AppleWebKit') != -1 && u.indexOf('Safari') != -1 && u.indexOf('CriOS') != -1) {
          this.chromeForIosClass = 'chrome-class'
        }
      }
    },
    setCustomDeviceScale() {
      // iPhone12,13 pro max
      let metaDom = document.querySelector("meta[name='viewport']")
      if (window.innerWidth == 428 && window.innerHeight == 926) {
        metaDom.content = "width=device-width, initial-scale=0.85,minimum-scale=0.85, maximum-scale=0.85, user-scalable=no"
      } else {
        metaDom.content = "width=device-width, initial-scale=1.0,minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"
      }
    }
  }
}
</script>

<style lang="less">
@import "./assets/style/accessibility";
@import "App";
</style>



// WEBPACK FOOTER //
// src/App.vue